import React, { Component } from "react";
import styled from "styled-components";
import LoginIcon from "../assets/404.png";

const NotFound = () => {
  return (
    <NotFoundDiv>
      <img src={LoginIcon} alt="" srcset="" />
    </NotFoundDiv>
  );
};

export default NotFound;

const NotFoundDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    height: 90vh;
    width: 90vw;
    object-fit: contain;
  }
`;
